<template>
  <nav ref="paginationElem" class="dynamic-tabs-pagination">
    <ol class="dynamic-tabs-pagination-items">
      <li v-if="currentPage > 1">
        <span class="dynamic-tabs-pagination-label" @click="prev">
          {{ prevLabel }}
        </span>
      </li>
      <li v-if="first">
        <a @click="onClickFirst">
          {{ first.title }}
        </a>
      </li>
      <li v-if="pageOffset > 0">
        <a @click="decreaseOffset">
          ...
        </a>
      </li>
      <li v-for="page in pages" :key="page.url">
        <a
          :class="{ 'is-current': page.isCurrent }"
          @click="$emit('change-page', page.title)"
        >
          {{ page.title }}
        </a>
      </li>
      <li v-if="pageCount > 5 && last">
        <a @click="increaseOffset">
          ...
        </a>
      </li>
      <li v-if="last">
        <a @click="onClickLast">
          {{ last.title }}
        </a>
      </li>
      <li v-if="currentPage !== pageCount">
        <span class="dynamic-tabs-pagination-label" @click="next">
          {{ nextLabel }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    prevLabel: {
      type: String
    },
    nextLabel: {
      type: String
    },
    pageCount: {
      type: Number
    },
    currentPage: {
      type: Number
    }
  },

  data() {
    return {
      pageOffset: 0
    };
  },

  computed: {
    pageNumbers() {
      return [...new Array(this.pageCount)]
        .map((_, index) => {
          const pageNumber = index + 1;

          return pageNumber;
        })
        .slice(this.pageOffset, this.pageOffset + 5);
    },

    pages() {
      return this.pageNumbers.map((pageNumber) => {
        const isCurrent = this.currentPage === pageNumber;

        return {
          isCurrent,
          title: pageNumber
        };
      });
    },

    first() {
      if (this.pageOffset > 0 && !this.pageNumbers.includes(1)) {
        return {
          title: 1
        };
      }

      return false;
    },

    last() {
      if (this.pageCount > 5 && !this.pageNumbers.includes(this.pageCount)) {
        return {
          title: this.pageCount
        };
      }

      return false;
    }
  },

  methods: {
    decreaseOffset() {
      const roundedDown = Math.floor((this.pageOffset - 1) / 5) * 5;

      this.pageOffset = roundedDown >= 0 ? roundedDown : 0;
    },

    increaseOffset() {
      this.pageOffset = Math.ceil((this.pageOffset + 1) / 5) * 5;
    },

    onClickFirst() {
      this.pageOffset = 0;

      this.$emit('change-page', this.first.title);
    },

    onClickLast() {
      this.pageOffset = this.pageCount - 5;

      this.$emit('change-page', this.pageCount);
    },

    next() {
      if (this.currentPage + 1 > this.pageOffset + 5) {
        this.increaseOffset();
      }

      this.$emit('change-page', this.currentPage + 1);
    },

    prev() {
      if (this.currentPage - 1 <= this.pageOffset) {
        this.decreaseOffset();
      }

      this.$emit('change-page', this.currentPage - 1);
    }
  }
};
</script>
